
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/advocacy/policy-making/ncoil",
      function () {
        return require("private-next-pages/advocacy/policy-making/ncoil.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/advocacy/policy-making/ncoil"])
      });
    }
  